import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader, Row, Col, Button } from 'reactstrap';
import { AvField, AvForm } from 'availity-reactstrap-validation';

const HolidayFormModal = ({
  isOpen,
  toggle,
  selectedDate,
  existing,
  onSave,
  onDelete,
}) => {
  const isWeeklyOff = existing?.type === 'weekly_off';
  const isWorkingDay = existing?.type === 'working_day';

  const handleValidSubmit = (_e, values) => {
    onSave({
      holiday_date: selectedDate,
      holiday_name: values.holiday_name,
      type: 'custom',
    });
  };

  const handleMarkAsWorkingDay = () => {
    onSave({
      holiday_date: selectedDate,
      holiday_name: 'Working Day',
      type: 'working_day',
    });
  };

  const title = isWeeklyOff
    ? 'Weekly Off'
    : isWorkingDay
      ? 'Working Day Override'
      : existing
        ? 'Edit Holiday'
        : 'Add Holiday';

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {title} — {selectedDate}
      </ModalHeader>
      <ModalBody>
        {isWeeklyOff && (
          <>
            <div className="alert alert-info py-2 mb-3">
              This date falls on the warehouse weekly-off day. Mark it as a
              working day if the warehouse will operate on this date.
            </div>
            <div className="d-flex justify-content-between">
              <Button
                color="success"
                type="button"
                onClick={handleMarkAsWorkingDay}
              >
                Mark as Working Day
              </Button>
              <Button color="secondary" type="button" onClick={toggle}>
                Cancel
              </Button>
            </div>
          </>
        )}

        {isWorkingDay && (
          <>
            <div className="alert alert-warning py-2 mb-3">
              This date is marked as a working day (overriding the warehouse
              weekly-off). Removing the override will restore the weekly-off
              for this date.
            </div>
            <div className="d-flex justify-content-between">
              <Button
                color="danger"
                type="button"
                onClick={() => onDelete(selectedDate)}
              >
                Remove Override
              </Button>
              <Button color="secondary" type="button" onClick={toggle}>
                Cancel
              </Button>
            </div>
          </>
        )}

        {!isWeeklyOff && !isWorkingDay && (
          <AvForm onValidSubmit={handleValidSubmit}>
            <Row>
              <Col xs={12} className="mb-3">
                <AvField
                  name="holiday_name"
                  label="Holiday Name"
                  type="text"
                  placeholder="e.g. National Day"
                  value={existing?.holiday_name || ''}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: 'Please enter a name',
                    },
                  }}
                />
              </Col>
            </Row>
            <div className="d-flex justify-content-between">
              <div>
                {existing && (
                  <Button
                    color="danger"
                    type="button"
                    onClick={() => onDelete(selectedDate)}
                  >
                    Delete
                  </Button>
                )}
              </div>
              <div>
                <Button
                  color="secondary"
                  type="button"
                  className="me-2"
                  onClick={toggle}
                >
                  Cancel
                </Button>
                <Button color="success" type="submit">
                  Save
                </Button>
              </div>
            </div>
          </AvForm>
        )}
      </ModalBody>
    </Modal>
  );
};

HolidayFormModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  selectedDate: PropTypes.string,
  existing: PropTypes.object,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
};

export default HolidayFormModal;
